<template>
    <TotemSelect
        :options="levelOptions"
        :placeholder="$t('CourseListFilter.skill_level')"
        @input="selectLevel"
        class="filter-select"
        ref="selectLevel"
        :isFilter="true"
        :reduce="option => String(option.level)"
        :value="selectedLevel"
    />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'UncompletedLevelFilter',
    props: {
        courseList: Array
    },
    computed: {
        ...mapGetters({
            selectedLevel: 'CourseFilter/getSelectedLevel',
        }),
        levelOptions() {
                const levels = [];

                this.courseList.forEach(course => {
                    const level = course.level

                    if (level !== null && level !== undefined && !levels.find(_level => +_level.level === +level)) {
                        const label = this.$t(`Select.skill_level_${level}`)
                        levels.push({label, level})
                    }

                    if (course.levels) {
                        course.levels.forEach((level) => {
                            if (level !== null && !levels.find(_level => +_level.level === +level)) {
                                const label = this.$t(`Select.skill_level_${level}`)
                                levels.push({label, level})
                            }
                        })

                    }
                })

                levels.sort((el, el2) => el.level - el2.level)
                return levels
            }
    },
    methods: {
        filterByLevel (data) {
            if (this.selectedLevel === null) {
                return data
            }
            const selectedLevel = Number(this.selectedLevel)

            return data.filter(item => {
                if (item.levels) {
                    return item.levels.includes(selectedLevel)
                }
                    return item.level === selectedLevel

                })
        },
        selectLevel (option) {
            this.$store.dispatch('CourseFilter/selectLevel', option)
        },
        clear () {
            this.$refs.selectLevel.clear()
        }
    }
}
</script>
